<template>
  <div v-if="showPopup" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 overflow-y-auto p-4">
    <div class="bg-white rounded-xl w-full max-w-4xl my-8 flex flex-col" style="max-height: calc(100vh - 4rem);">
      <!-- Header -->
      <div class="bg-primary text-white px-4 py-2 rounded-t-xl flex justify-between items-center flex-shrink-0">
        <h1 class="heading-3">{{ isEditMode ? 'Edit Job' : 'Create Job' }}</h1>
        <button @click="discardForm" class="text-white hover:text-gray-200">
          <i class="fa-solid fa-times text-2xl"></i>
        </button>
      </div>

      <!-- Body - Scrollable -->
      <div class="p-0 overflow-y-auto flex-1">
        <div class="p-4 pb-0">
          <!-- Customer & Location Section -->
          <div class="sm:grid grid-cols-2 gap-4">
            <div class="mb-4 sm:mb-0">
              <Dropdown
                :disabled="isDisable"
                :inputext="searchForCustomer"
                :inputId="'searchwp-Customer'"
                :lableText="''"
                :placholderText="'Customer'"
                :autoFocus="true"
                :showArrow="true"
                :setReadOnly="false"
                :searchCallApi="true"
                :fieldError="errObj.custErr !== ''"
                :showPlus="true"
                :keyName="'displayName'"
                :listId="'customerlistid'"
                :items="customersList"
                :renderHtml="true"
                @enterkeyPressAction="errObj.custErr = ''"
                @inputChangeAction="callsearchCust"
                @addNew="addNewCustomer"
                @selectNewForVal="selectNewCustomer"
                placeholderType="floating"
              />
              <p v-if="errObj.custErr !== ''" class="text-error heading-7">
                {{ errObj.custErr }}
              </p>
            </div>

            <div v-if="custDetail !== null" class="mb-4 sm:mb-0 flex items-center">
              <div v-if="custDetail.hotNotes !== ''" class="flex items-center ml-4 pt-2">
                <span @click="showAddNote = true" class="text-primary cursor-pointer">
                  <i class="fa-solid fa-pen-to-square h-5 w-5"></i>
                </span>
              </div>
              <div v-if="!showHotNote && custDetail.hotNotes !== ''" class="flex items-center px-4 pt-2">
                <span @click="showHotNote = true" class="text-primary cursor-pointer">Show Hot Notes</span>
                <InfoTooltip tooltipText="Hot notes is a note that shows next to customer all the time for you to get a quick information about the customer" position="right" class="ml-2"/>
              </div>
              <div v-else-if="showHotNote" class="flex items-center px-4 pt-2">
                <span @click="showHotNote = false" class="text-primary cursor-pointer">Hide Hot Notes</span>
                <InfoTooltip tooltipText="Hot notes is a note that shows next to customer all the time for you to get a quick information about the customer" position="right" class="ml-2"/>
              </div>
              <div v-else-if="custDetail.hotNotes === ''" class="flex items-center px-4 pt-2">
                <span @click="showAddNote = true" class="text-primary cursor-pointer">Enter Hot Notes</span>
                <InfoTooltip tooltipText="Hot notes is a note that shows next to customer all the time for you to get a quick information about the customer" position="right" class="ml-2"/>
              </div>
            </div>
            <div v-if="custDetail !== null && showHotNote" class="mb-4 sm:mb-0 flex items-center col-span-2">
              <p class="label_css">Hot Note</p><span style="width: 10px; margin-left: 5px;">: </span><p class="text-error"> {{ custDetail.hotNotes }}</p>
            </div>

            <div class="mb-4 sm:mb-0 col-span-2">
              <TextField
                :inputId="'jobtitlename'"
                :textMaxlength="100"
                :showcharLimit="true"
                :inputext="addJobObj.jobTitle"
                :fieldError="errObj.titleErr !== ''"
                :placholderText="'Job Title'"
                :lableText="''"
                :autoFocus="false"
                @keyPressAction="errObj.titleErr = ''"
                @inputChangeAction="(data) => (addJobObj.jobTitle = data)"
                placeholderType="floating"
              />
              <p class="text-error heading-7">{{ errObj.titleErr }}</p>
            </div>
            <div class="mb-4 sm:mb-0 col-span-2 mt-0">
            <div @click.capture="checkCustomerSelected">
              <Dropdown
                :disabled="false"
                :lableText="''"
                :placholderText="'Select job location'"
                :inputext="selectedAddressLabel"
                :showArrow="true"
                :setReadOnly="false"
                :searchCallApi="false"
                :fieldError="errObj.addressErr !== ''"
                :keyName="'label'"
                :autoFocus="false"
                :showPlus="custDetail !== null"
                :showClearIcon="true"
                :inputId="'address-dropdown'"
                :listId="'address-list'"
                :items="addressDropdownItems"
                :disbled="custDetail !== null"
                @selectNewForVal="handleAddressSelect"
                @addNew="addNewAddress"
                placeholderType="floating"
              />
            </div>
            <p v-if="errObj.addressErr !== ''" class="text-error heading-7">
              {{ errObj.addressErr }}
            </p>

            <p v-if="selectedAddress && selectedAddress.type === 'customer'" class="text-text2 heading-7 mt-1">
              {{ selectedAddress.data.displayDistance }}
            </p>
            <!-- <p v-else-if="isOfficeAddressSel && selectedAddress && selectedAddress.address" class="text-text2 heading-7 mt-1">
              Office Location Selected
            </p> -->
            <p v-else-if="isAddedNewAddress" class="text-error heading-7 mt-1">
              {{ otherLocationDistance }}
            </p>

            <div v-if="isAddedNewAddress" class="flex items-center mt-2">
              <CheckBoxInput
                :checkValue="addJobObj.isAddressAddToCustomer"
                :label="''"
                :size="'small'"
                :disabled="false"
                @setIsActive="addJobObj.isAddressAddToCustomer = !addJobObj.isAddressAddToCustomer"
              />
              <span class="pl-0 text-text2 cursor-pointer" @click.stop.prevent="addJobObj.isAddressAddToCustomer = !addJobObj.isAddressAddToCustomer">
                Add address in customer file
              </span>
            </div>
          </div>
            <div class="col-span-2 mb-0">
              <TextAreaInput
                :inputId="'jobdescriptioncon'"
                :inputext="stepTwoObj.jobDescription"
                :placholderText="'Write description here...'"
                :lableText="''"
                :inputType="'text'"
                :autoFocus="false"
                :textMaxlength="1000"
                :showcharLimit="true"
                class="w-full"
                :setReadOnly="false"
                @inputChangeAction="(data) => (stepTwoObj.jobDescription = data)"
                placeholderType="floating"
              />
            </div>
          </div>

          <div class="grid grid-cols-2 mt-4">
            <div class="col-span-2">
              <div class="card rounded-lg border border-gray2 bg-white overflow-visible">
                <div class="p-4">
                  <div class="mb-4">
                    <p class="heading-6 font-semibold text-text1 mb-3 flex">Select Job Type<InfoTooltip tooltipText="Job type will help you to categorize jobs based and will help you in reporting" position="right" class="ml-2"/></p>
                    <div class="flex flex-wrap">
                      <span v-for="(type, index) in jobTypeList" :key="index">
                        <span
                          @click="selectJobType(type)"
                          :class="`mb-1 cursor-pointer flex items-center justify-center w-fit heading-6 whitespace-nowrap border rounded-2xl text-${stepTwoObj.jobTypeId === type.jobTypeId ? 'primary' : ''} border-${stepTwoObj.jobTypeId === type.jobTypeId ? 'primary' : 'gray2'} px-2 py-1 mr-1`"
                        >
                          {{ type.jobTypeName }}
                        </span>
                      </span>
                    </div>
                  </div>

                  <div class="divider mb-4"></div>

                  <div class="mb-4">
                    <p class="heading-6 font-semibold text-text1 mb-3 flex">Billing <InfoTooltip tooltipText="Billable will remind you to generate bill before job completion Non Billable will not remind you to create bill on job completion Not application - not yet decided if this job will require billing" position="right" class="ml-2"/></p>
                    <div class="flex flex-wrap gap-4">
                      <label class="flex items-center cursor-pointer">
                        <input
                          type="radio"
                          name="billingStatus"
                          :value="true"
                          v-model="stepTwoObj.isBillable"
                          class="mr-2 cursor-pointer"
                        />
                        <span class="heading-6">Billable</span>
                      </label>
                      <label class="flex items-center cursor-pointer">
                        <input
                          type="radio"
                          name="billingStatus"
                          :value="false"
                          v-model="stepTwoObj.isBillable"
                          class="mr-2 cursor-pointer"
                        />
                        <span class="heading-6">Not Billable</span>
                      </label>
                      <label class="flex items-center cursor-pointer">
                        <input
                          type="radio"
                          name="billingStatus"
                          :value="null"
                          v-model="stepTwoObj.isBillable"
                          class="mr-2 cursor-pointer"
                        />
                        <span class="heading-6">Not Applicable</span>
                      </label>
                    </div>
                  </div>

                  <div class="divider mb-4"></div>

                  <div class="flex items-center">
                    <CheckBoxInput
                      :checkValue="stepTwoObj.isVipJob"
                      :label="'VIP Job'"
                      :size="'small'"
                      :disabled="false"
                      @setIsActive="stepTwoObj.isVipJob = !stepTwoObj.isVipJob"
                    />
                    <InfoTooltip tooltipText="VIP Job will show a Star in job list and detail for you to know its an important job" position="right" class="ml-2"/>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="grid grid-cols-2 mt-0">
            <div class="col-span-2 mt-4">
              <div class="card rounded-lg border border-gray2 bg-white overflow-visible">
                <div class="p-4">
                  <p class="heading-6 font-semibold text-text1 mb-3">Schedule</p>
                  <SheduleVisit
                    :sTime="ssTime"
                    :eTime="eeTime"
                    :assignUser="assignUser"
                    :isFromSchedule="false"
                    :showEmployeeSelection="false"
                    :showJobItemSelection="false"
                    :visitErr="visitErr"
                    :jobDetail="jobDetailObj"
                    :isCreateJob="true"
                    :isShowJobSection="true"
                    :setDefaultTime="ssTime !== '' && eeTime !== '' ? true : false"
                    :title="''"
                  />
                </div>
              </div>
            </div>

            <div class="col-span-2 mt-4">
              <div class="card rounded-lg border border-gray2 bg-white overflow-visible">
                <div class="p-4">
                  <div class="mb-4">
                    <div v-if="selectedEmployee.length > 0" class="flex items-center mb-2">
                      <p class="label_css mb-0">Assign to:</p>
                      <span @click="openSelectEmployeePopup" class="text-primary cursor-pointer ml-2 heading-6">Add/Edit</span>
                    </div>
                    <div>
                      <div v-if="selectedEmployee.length > 0" class="mb-3 ml-6">
                        <div v-for="(emp, index) in selectedEmployee" :key="index" class="flex items-center py-2 border-b border-gray-200">
                          <i class="fas fa-user text-primary mr-3"></i>
                          <span class="text-text1 heading-6">{{ emp.fullName }}</span>
                        </div>
                      </div>
                      <div v-if="selectedEmployee.length === 0" class="flex items-center">
                        <span @click="openSelectEmployeePopup" class="text-primary font-bold cursor-pointer">
                          + Add Employee
                        </span>
                        <InfoTooltip tooltipText="Assign employees who will work on this job" position="top" class="ml-2"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-span-2 mt-4">
              <div class="card rounded-lg border border-gray2 bg-white overflow-hidden expandable-card">
                <div
                  @click="showMore = !showMore"
                  class="flex justify-between items-center p-4 cursor-pointer hover:bg-gray-50 transition-colors"
                >
                  <div class="flex items-center">
                    <span class="heading-5 font-semibold text-text1">Additional Options</span>
                  </div>
                  <i
                    :class="['fa-solid fa-chevron-down text-primary transition-transform duration-300', showMore ? 'rotate-180' : '']"
                  ></i>
                </div>

                <div v-if="showMore" class="border-t border-gray2">
                  <div class="p-4">
                    <div class="mb-4">
                      <JobItemSelect
                        :itemList="stepThreeObj.itemList"
                        @update:itemList="stepThreeObj.itemList = $event"
                        @popupStateChanged="isItemSelectionOpen = $event"
                      />
                    </div>
                    <div class="divider mb-4 mt-4"></div>

                    <div class="mb-4">
                      <div v-if="jobCheckList != null && jobCheckList.length > 0" class="flex items-center mb-2">
                        <p class="label_css mb-0">Job Checklist</p>
                        <span @click="openChecklistPopup" class="text-primary cursor-pointer ml-2 heading-6">Add/Edit</span>
                      </div>
                      <div>
                        <div v-if="jobCheckList != null && jobCheckList.length > 0" class="mb-3 ml-6">
                          <div v-for="(item, ch) in jobCheckList" :key="ch" class="flex items-center py-2 border-b border-gray-200">
                            <i class="fas fa-check-circle text-primary mr-3"></i>
                            <span class="text-text1 heading-6">{{ item.checkLiTitle }}</span>
                          </div>
                        </div>
                        <div v-if="jobCheckList == null || jobCheckList.length === 0" class="flex items-center">
                          <span @click="openChecklistPopup" class="text-primary font-bold cursor-pointer">
                            + Add Checklist
                          </span>
                          <InfoTooltip v-if="!isItemSelectionOpen" tooltipText="Checklist will help you to check things before you leave for the job" position="top" class="ml-2"/>
                        </div>
                      </div>
                    </div>

                    <div class="divider mb-4 mt-4"></div>

                    <div class="mb-4">
                      <div v-if="stepThreeObj.toolList != null && stepThreeObj.toolList.length > 0" class="flex items-center mb-2">
                        <p class="label_css mb-0">Tool list:</p>
                        <span @click="openSelectToolPopup" class="text-primary cursor-pointer ml-2 heading-6">Add/Edit</span>
                      </div>
                      <div>
                        <div v-if="stepThreeObj.toolList != null && stepThreeObj.toolList.length > 0" class="mb-3 ml-6">
                          <div v-for="(tool, ind) in stepThreeObj.toolList" :key="ind" class="flex items-center py-2 border-b border-gray-200">
                            <i class="fas fa-tools text-primary mr-3"></i>
                            <span class="text-text1 heading-6">{{ tool.toolName }}</span>
                          </div>
                        </div>
                        <div v-if="stepThreeObj.toolList == null || stepThreeObj.toolList.length === 0" class="flex items-center">
                          <span @click="openSelectToolPopup" class="text-primary font-bold cursor-pointer">
                            + Add Tools
                          </span>
                          <InfoTooltip v-if="!isItemSelectionOpen" tooltipText="Tools will help you to carry tools before you start the day so that you don't miss anything during the job" position="top" class="ml-2"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!isEditMode" class="p-3">
            <p class="heading-6 font-normal text-text1 mb-0">Attach file to this job? (once job is created you can attach files)</p>
          </div>

          <!-- Save and Discard Buttons -->
          <div class="flex justify-end col-span-2 mt-6 mb-4">
            <div class="text-right flex gap-2">
              <Button
                :btnSize="'medium'"
                :textColor="'text1'"
                :btnColor="'gray1'"
                :btnText="'Cancel'"
                @buttonAction="discardForm"
              />
              <Button
                :btnSize="'medium'"
                :textColor="'white'"
                :btnColor="'success'"
                :btnText="isEditMode ? 'Save Changes' : 'Save'"
                @buttonAction="saveForm"
                :disabled="!isEditMode && custDetail === null"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Sub-components/popups -->
    <AddCustomer v-if="addCustomer" />
    <AddAddressForCreateJob
      v-if="addOther"
      :addJobObj="addJobObj"
      :addressList="addressList"
      @SearchNewAddress="SearchNewAddress"
      @SetLocationCreateJobHanler="SetLocationCreateJobHanler"
    />
    <UpdateCompanyInfo
      v-if="showAddNote"
      :dialogTtile="'Update Hot Notes'"
      :updateCustData="custDetail"
    />
    <AddressAdd :showAdditional="true" v-show="addNewjobAdd" :addedAddress="addedAddress" />
    <SelectTools
      @uppdateToollist="uppdateToollist"
      :toolList="toolMainList"
      :selectedTools="stepThreeObj.toolList"
      @selectToolHandler="selectToolHandler"
      v-if="isSelectTool"
    />
    <SelectChecklist
      :checklist="jobCheckList"
      @checklistHandler="handleChecklistSave"
      v-if="isSelectChecklist"
    />
    <SelectEmployee
      :employees="employeeList"
      :selectedEmployees="selectedEmployee"
      @selectEmployeeHandler="handleEmployeeSelect"
      v-if="isSelectEmployee"
    />
    <ConfirmBox v-if="showCustomerChangeConfirm" :warning="false"
      :message="'Changing the customer will also change the address to updated customer default address. Do you want to continue?'" :title="'Change Customer?'" :cancelbtnText="'Cancel Change'" :confirmBtnText="'Change Customer'" :rbtnColor="'primary'" @confirmBoxHandler="handleCustomerChangeConfirm"/>
    <ConfirmBox v-if="isCancelChanges" :warning="false" :cancelbtnText="'Cancel Job'" :confirmBtnText="'Continue Editing'" :rbtnColor="'primary'"
      :message="'You have unsaved changes. Do you want to discard them?'" :title="'Unsaved Changes!'" @confirmBoxHandler="handleDiscardConfirm" />
    <ConfirmBox v-if="showSelectCustomerFirst" :warning="true" :showCancelBtn="false" :confirmBtnText="'Yes'"
      :message="'Please select the customer first'" :title="'Customer Required'" @confirmBoxHandler="handleSelectCustomerFirstConfirm"/>
  </div>
</template>

<script>
import MyJobApp from "@/api/MyJobApp.js";
import Button from "@/View/components/globalButton.vue";
import TextAreaInput from "@/View/components/textAreaInput.vue";
import SheduleVisit from './SheduleVisit.vue';
import timeZoneWithCountryCode from '@/assets/timeZoneWithCountryCode.json';
import milesCountry from '@/assets/milesCountry.json';
import Dropdown from "@/View/components/dropdown.vue";
import TextField from "@/View/components/textfield.vue";
import deboucneMixin from "@/mixins/debounce.js";
import AddCustomer from "../../customer/components/AddCustomer.vue";
import UpdateCompanyInfo from "../../customer/components/UpdateCompanyInfo.vue";
import AddressAdd from '../../components/AddressAdd.vue';
import CheckBoxInput from '../../components/checkBoxInput.vue';
import SelectTools from './selectTools.vue';
import SelectChecklist from './SelectChecklist.vue';
import SelectEmployee from './SelectEmployee.vue';
import AddAddressForCreateJob from './AddAddressForCreateJob.vue';
import JobItemSelect from './JobItemSelect.vue';
import ConfirmBox from '@/View/components/ConfirmBox.vue'
import InfoTooltip from '@/View/components/InfoTooltip.vue'

export default {
  name: "CreateJobPopup",
  components: {
    Button,
    TextAreaInput,
    SheduleVisit,
    Dropdown,
    TextField,
    AddCustomer,
    UpdateCompanyInfo,
    AddressAdd,
    CheckBoxInput,
    SelectTools,
    SelectChecklist,
    SelectEmployee,
    AddAddressForCreateJob,
    JobItemSelect,
    ConfirmBox,
    InfoTooltip
  },
  mixins: [deboucneMixin],
  props: {
    showPopup: {
      type: Boolean,
      default: false
    },
    isEditMode: {
      type: Boolean,
      default: false
    },
    jobDetail: {
      type: Object,
      default: null
    },
    visitDetail: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      showMore: false,
      ssTime: '',
      eeTime: '',
      errObj: {
        custErr: "",
        titleErr: "",
        addressErr: "",
      },
      addJobObj: {
        jobId: 0,
        customerId: 0,
        jobNumber: "",
        jobTitle: "",
        jobStartTime: "",
        jobEndTime: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        latitude: 0,
        longitude: 0,
        geofenceRangeDiameter: 0,
        fullAddress: "",
        houseNo: "",
        floorNumber: "",
        buildingName: "",
        directionNote: "",
        contactNumber: "",
        contactName: "",
        isAddressAddToCustomer: false,
        requestType: "",
        detailId: 0,
        addressTitle: '',
      },
      stepTwoObj: {
        jobId: 0,
        jobDescription: "",
        isVipJob: false,
        isBillable: false,
        jobTypeId: 0,
        jobEstimation: 0,
        visitCheckList: "",
      },
      stepThreeObj: {
        jobId: 0,
        visitList: [],
        isUnschedule: false,
        assignToList: [],
        itemList: [],
        toolList: [],
      },
      addedAddress: null,
      visitErr: false,
      isSelectTool: false,
      isSelectChecklist: false,
      isSelectEmployee: false,
      isItemSelectionOpen: false,
      isAddedNewAddress: false,
      addNewjobAdd: false,
      isOfficeAddressSel: false,
      selectedEmployee: [],
      employeeList: [],
      pendingAssignToList: null,
      showAddNote: false,
      jobDisplayAdd: "",
      showAddSelectAddr: false,
      showHotNote: false,
      addCustomer: false,
      custDetail: null,
      isDisable: false,
      resetPaginationValues: false,
      searchForCustomer: "",
      searchApitext: "",
      customersList: [],
      addressList: [],
      jobTypeList: [],
      hourInputValue: 0,
      minInputValue: 0,
      jobDetailObj: null,
      jobCheckList: [],
      displayEstimation: '',
      LoginUserlatLong: null,
      OfficelatLong: null,
      displayDistance: '',
      toolMainList: [],
      timeCounter: 0,
      displayJobTypeName: '',
      otherLocationDistance: '',
      addOther: false,
      assignUser: 0,
      selectedAddress: null,
      selectedAddressLabel: '',
      addressDropdownItems: [],
      showCustomerChangeConfirm: false,
      pendingCustomerData: null,
      isCancelChanges: false,
      isFormDirty: false,
      initialFormState: {},
      showSelectCustomerFirst: false,
      isInitializingEditMode: false,
      editModeAddressData: null,
      editModeOriginalAddress: null,
    };
  },
watch: {
  showPopup: {
    handler(newVal) {
      if (!newVal) {
        document.body.style.overflow = 'auto';
        return;
      }

      document.body.style.overflow = 'hidden';
      this.initializePopup();

      if (this.isEditMode && this.jobDetail) {
        this.$nextTick(() => {
          this.initializeEditMode();
        });
      }

      this.$nextTick(() => {
        this.saveInitialFormState();
      });
    },
    immediate: true
  },

  // 'jobDetail.jobId': {
  //   handler(newVal) {
  //     if (newVal && this.showPopup && this.isEditMode && !this.isInitializingEditMode) {
  //       this.$nextTick(() => {
  //         console.log("inside jobDetail.jobId")
  //         this.initializeEditMode();
  //       });
  //     }
  //   },
  //   immediate: true
  // },

  addJobObj: {
    handler() {
      this.isFormDirty = true;
    },
    deep: true
  },

  stepTwoObj: {
    handler() {
      this.isFormDirty = true;
    },
    deep: true
  },

  stepThreeObj: {
    handler() {
      this.isFormDirty = true;
    },
    deep: true
  },

  jobCheckList: {
    handler() {
      this.isFormDirty = true;
    },
    deep: true
  },

  selectedAddress: {
    handler() {
      this.isFormDirty = true;
    },
    deep: true
  }
},
  mounted() {
    this.LoginUserlatLong = JSON.parse(localStorage.getItem('LoginUserlatLong'));
    this.OfficelatLong = JSON.parse(localStorage.getItem('orgInfo'));
    this.getEmployeeList();
    this.$root.$on("createjobAddressHandler", (response, data) => {
      if (response && data !== null && this.addOther) {
        this.setAddress(data, false);
        // Save address to customer if customer is selected
        if (this.custDetail && this.custDetail.customerId) {
          this.saveAddressToCustomer(data);
        }
      }
      this.addOther = false;
    });
    this.$root.$on('EditAddressHandler', (response, data) => {
      if (this.addNewjobAdd) {
        if (response && data !== null) {
          // Update address in the database
          if (this.custDetail && this.custDetail.customerId) {
            this.updateAddressInCustomer(data);
          }
        }
        this.addNewjobAdd = false;
      }
    });
    this.$root.$on("addAddressHandler", (response, data) => {
      if (response && data !== null && this.addNewjobAdd) {
        this.setAddress(data);
        // Save address to customer if customer is selected
        if (this.custDetail && this.custDetail.customerId) {
          this.saveAddressToCustomer(data);
        }
        this.addOther = false;
      }
      this.addNewjobAdd = false;
    });
    this.$root.$on("updateCustHandler", (response) => {
      this.showAddNote = false;
      if (response) {
        this.getCustDetails(this.custDetail.customerId);
      }
    });
    this.$root.$on("addCustomerHandler", (response, data) => {
      if (response && this.addCustomer) {
        this.selectNewCustomer(data);
      }
      this.addCustomer = false;
    });
    this.getCustList = this.debounce(function () {
      this.getCustomerList();
    }, 500);
    this.$root.$on('finalvisitlistHandler', (response) => {
      if (response[0].isUnschedule) {
        this.stepThreeObj.visitList = [];
        this.stepThreeObj.isUnschedule = true;
      } else {
        this.stepThreeObj.visitList = response;
        this.stepThreeObj.isUnschedule = false;
      }
      this.visitErr = false;
    });
    this.$root.$on('setSelectedEmpHandler', (response) => {
      this.stepThreeObj.assignToList = response;
    });
    this.$root.$on('setItemSelectedHandler', (response) => {
      this.stepThreeObj.itemList = Array.isArray(response) ? [...response] : [];
    });
  },
  beforeDestroy() {
    document.body.style.overflow = 'auto';
    this.$root.$off("updateCustHandler");
    this.$root.$off("addCustomerHandler");
    this.$root.$off("setItemSelectedHandler");
    this.$root.$off("addAddressHandler");
    this.$root.$off("finalvisitlistHandler");
    this.$root.$off("setSelectedEmpHandler");
    this.$root.$off("createjobAddressHandler");
    this.$root.$off("EditAddressHandler");
  },
  methods: {
    initializePopupWhenReady() {
      if (!this.isEditMode) {
        this.resetFormData();
      }
      this.initializePopup();

      // If we're in edit mode and jobDetail is already available → init immediately
      if (this.isEditMode && this.jobDetail) {
        this.$nextTick(() => {
          this.initializeEditMode();
        });
      }
      // Otherwise jobDetail watcher will catch it when it arrives

      document.body.style.overflow = 'hidden';
      this.$nextTick(() => {
        this.saveInitialFormState();
      });
    },
    resetFormData() {
      // Reset all form data
      this.searchForCustomer = "";
      this.searchApitext = "";
      this.custDetail = null;
      this.showAddSelectAddr = false;
      this.showHotNote = false;
      this.showMore = false;
      this.isDisable = false;

      // Reset error objects
      this.errObj = {
        custErr: "",
        titleErr: "",
        addressErr: "",
      };

      // Reset job objects
      this.addJobObj = {
        jobId: 0,
        customerId: 0,
        jobNumber: "",
        jobTitle: "",
        jobStartTime: "",
        jobEndTime: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        latitude: 0,
        longitude: 0,
        geofenceRangeDiameter: 0,
        fullAddress: "",
        houseNo: "",
        floorNumber: "",
        buildingName: "",
        directionNote: "",
        contactNumber: "",
        contactName: "",
        isAddressAddToCustomer: false,
        requestType: "",
        detailId: 0,
        addressTitle: '',
      };

      this.stepTwoObj = {
        jobId: 0,
        jobDescription: "",
        isVipJob: false,
        isBillable: false,
        jobTypeId: 0,
        jobEstimation: 0,
        visitCheckList: "",
      };

      this.stepThreeObj = {
        jobId: 0,
        visitList: [],
        isUnschedule: false,
        assignToList: [],
        itemList: [],
        toolList: [],
      };

      // Reset other state
      this.selectedAddress = null;
      this.selectedAddressLabel = '';
      this.addressDropdownItems = [];
      this.addressList = [];
      this.isOfficeAddressSel = false;
      this.isAddedNewAddress = false;
      this.jobCheckList = [];
      this.selectedEmployee = [];
      this.pendingAssignToList = null;
      this.toolMainList = [];
      this.ssTime = '';
      this.eeTime = '';
      this.isFormDirty = false;
      this.isCancelChanges = false;
    },
    saveInitialFormState() {
      this.initialFormState = JSON.parse(JSON.stringify({
        customerId: this.addJobObj.customerId,
        jobTitle: this.addJobObj.jobTitle,
        isBillable: this.stepTwoObj.isBillable,
        isVipJob: this.stepTwoObj.isVipJob,
        jobDescription: this.stepTwoObj.jobDescription,
        addressLine1: this.addJobObj.addressLine1,
        addressLine2: this.addJobObj.addressLine2,
        city: this.addJobObj.city,
        state: this.addJobObj.state,
        zip: this.addJobObj.zip,
        isAddressAddToCustomer: this.addJobObj.isAddressAddToCustomer,
        jobCheckList: this.jobCheckList,
        toolList: this.stepThreeObj.toolList,
        itemList: this.stepThreeObj.itemList,
        // selectedEmployee: this.selectedEmployee
      }));
      this.isFormDirty = false;
    },
    checkIfFormIsDirty() {
      const current = {
        customerId: this.addJobObj.customerId,
        jobTitle: this.addJobObj.jobTitle,
        isBillable: this.stepTwoObj.isBillable,
        isVipJob: this.stepTwoObj.isVipJob,
        jobDescription: this.stepTwoObj.jobDescription,
        addressLine1: this.addJobObj.addressLine1,
        addressLine2: this.addJobObj.addressLine2,
        city: this.addJobObj.city,
        state: this.addJobObj.state,
        zip: this.addJobObj.zip,
        isAddressAddToCustomer: this.addJobObj.isAddressAddToCustomer,
        jobCheckList: this.jobCheckList,
        toolList: this.stepThreeObj.toolList,
        itemList: this.stepThreeObj.itemList,
        // selectedEmployee: this.selectedEmployee
      };
      return JSON.stringify(current) !== JSON.stringify(this.initialFormState);
    },
    discardForm() {
      if (this.checkIfFormIsDirty()) {
        this.isCancelChanges = true;
      } else {
        this.closePopup();
      }
    },
    handleDiscardConfirm(confirmed) {
      if (!confirmed) {
        // User confirmed to discard changes
        this.closePopup();
      }
      // User wants to continue editing, just close the confirmation dialog
      document.body.style.overflow = 'hidden';
      this.isCancelChanges = false;
    },
    initializePopup() {
      this.getCustomerList();
      this.getToolList();
      this.jobTypelist();
      if (!this.isEditMode) {
        this.setDefaultEmployee();
      }
    },
    initializeEditMode() {
      // Prevent setCustomerDetail() from auto-selecting the wrong address
      this.isInitializingEditMode = true;

      // --- 1. BASIC JOB INFO ---
      this.addJobObj.jobId = this.jobDetail.jobId;
      this.addJobObj.customerId = this.jobDetail.customerId;
      this.addJobObj.jobTitle = this.jobDetail.jobTitle || "";
      this.addJobObj.jobNumber = this.jobDetail.jobNumber || "";

      // --- 2. ADDRESS (SAVE IT BEFORE customer load overwrites it!) ---
      console.log("editModeOriginalAddress Before", this.editModeOriginalAddress)
      console.log("jobDetail", this.jobDetail)

      this.editModeOriginalAddress = {
        addressTitle: this.jobDetail.addressTitle || "",
        fullAddress: this.jobDetail.fullAddress || "",
        addressLine1: this.jobDetail.addressLine1 || "",
        addressLine2: this.jobDetail.addressLine2 || "",
        city: this.jobDetail.city || "",
        state: this.jobDetail.state || "",
        zip: this.jobDetail.zip || "",
        country: this.jobDetail.country || "",
        latitude: this.jobDetail.latitude || 0,
        longitude: this.jobDetail.longitude || 0,
        houseNo: this.jobDetail.houseNo || "",
        floorNumber: this.jobDetail.floorNumber || "",
        buildingName: this.jobDetail.buildingName || "",
        directionNote: this.jobDetail.directionNote || "",
        contactName: this.jobDetail.contactName || "",
        contactNumber: this.jobDetail.contactNumber || "",
        geofenceRangeDiameter: this.jobDetail.geofenceRangeDiameter || 100,
      };
      console.log("editModeOriginalAddress Before", this.editModeOriginalAddress)

      // Temporarily set the label so user sees correct address immediately
      this.selectedAddressLabel = this.editModeOriginalAddress.addressTitle
        ? `${this.editModeOriginalAddress.addressTitle} - ${this.editModeOriginalAddress.fullAddress}`
        : this.editModeOriginalAddress.fullAddress || "Address";

      // Immediately populate addJobObj with address fields so they're available in payload
      Object.assign(this.addJobObj, {
        addressTitle: this.editModeOriginalAddress.addressTitle || "",
        fullAddress: this.editModeOriginalAddress.fullAddress || "",
        addressLine1: this.editModeOriginalAddress.addressLine1 || "",
        addressLine2: this.editModeOriginalAddress.addressLine2 || "",
        city: this.editModeOriginalAddress.city || "",
        state: this.editModeOriginalAddress.state || "",
        zip: this.editModeOriginalAddress.zip || "",
        country: this.jobDetail.country || "",
        latitude: this.editModeOriginalAddress.latitude || 0,
        longitude: this.editModeOriginalAddress.longitude || 0,
        houseNo: this.editModeOriginalAddress.houseNo || "",
        floorNumber: this.editModeOriginalAddress.floorNumber || "",
        buildingName: this.editModeOriginalAddress.buildingName || "",
        directionNote: this.editModeOriginalAddress.directionNote || "",
        contactName: this.editModeOriginalAddress.contactName || "",
        contactNumber: this.editModeOriginalAddress.contactNumber || "",
        geofenceRangeDiameter: this.editModeOriginalAddress.geofenceRangeDiameter || 100,
      });

      // --- 3. STEP 2: Description, VIP, Billable, Job Type ---
      this.stepTwoObj.jobId = this.jobDetail.jobId;
      this.stepTwoObj.jobDescription = this.jobDetail.jobDescription || "";
      this.stepTwoObj.isVipJob = this.jobDetail.isVipJob || false;
      this.stepTwoObj.isBillable = this.jobDetail.isBillable; // can be true/false/null
      this.stepTwoObj.jobTypeId = this.jobDetail.jobTypeId || 0;
      this.stepTwoObj.jobEstimation = this.jobDetail.jobEstimation || 0;

      // --- 4. CUSTOMER DISPLAY ---
      this.searchForCustomer = this.jobDetail.companyName || "";
      this.custDetail = { customerId: this.jobDetail.customerId }; // minimal object
      this.isDisable = true; // disable customer dropdown in edit

      // --- 5. LOAD FULL CUSTOMER DETAILS (this will trigger setCustomerDetail) ---
      if (this.jobDetail.customerId) {
        this.getCustDetails(this.jobDetail.customerId);
      }

      // --- 6. SCHEDULE & VISIT DATA ---
      this.stepThreeObj.jobId = this.jobDetail.jobId;

      let visit = null;
      let visitListSource = [];

      if (this.jobDetail.visitList?.length > 0) {
        visit = this.jobDetail.visitList[0];
        visitListSource = this.jobDetail.visitList;
        this.stepThreeObj.isUnschedule = false;
      } else if (this.jobDetail.completeVisitList?.length > 0) {
        visit = this.jobDetail.completeVisitList[0];
        visitListSource = this.jobDetail.completeVisitList;
        this.stepThreeObj.isUnschedule = false;
      } else {
        // No visits means it's unscheduled
        this.stepThreeObj.visitList = [];
        this.stepThreeObj.isUnschedule = true;
      }
      // console.log('visitDetails', visitListSource)
      // Transform visitList to match API payload format
      if (visitListSource.length > 0) {
        this.stepThreeObj.visitList = visitListSource.map(v => ({
          visitStartDateTime: v.visitStartDateTime || null,
          visitEndDateTime: v.visitEndDateTime || null,
          Error: false,
          isUnschedule: false,
          visitEstimation: v.visitEstimation || 0
        }));
      }

      if (visit) {
        // Set schedule times - ensure they're Date objects or empty strings
        this.ssTime = visit.visitStartDateTime ? new Date(visit.visitStartDateTime) : "";
        this.eeTime = visit.visitEndDateTime ? new Date(visit.visitEndDateTime) : "";

        this.addJobObj.jobStartTime = this.ssTime;
        this.addJobObj.jobEndTime = this.eeTime;

        // Emit to SheduleVisit component to update its internal state
        this.$nextTick(() => {
          this.$root.$emit('setEditModeScheduleTimes', {
            startTime: this.ssTime,
            endTime: this.eeTime
          });
        });
        
        if (visit.visitAssignee?.length > 0) {
          this.pendingAssignToList = visit.visitAssignee;

          // Store in stepThreeObj.assignToList immediately in API format
          this.stepThreeObj.assignToList = visit.visitAssignee.map(emp => ({
            userDetailId: emp.userDetailId
          }));

        } else {
          console.log('No visitAssignee found in visit');
        }

        // Checklist
        let checklist = this.visitDetail.visitCheckList || "";
        if (checklist) {
          try {
            this.jobCheckList = typeof checklist === "string" ? JSON.parse(checklist) : checklist;
            this.stepTwoObj.visitCheckList = checklist;
          } catch (e) {
            console.error("Failed to parse checklist", e);
            this.jobCheckList = [];
            this.stepTwoObj.visitCheckList = "";
          }
        }

        // Tools
        if (this.visitDetail.toolList?.length > 0) {
          this.stepThreeObj.toolList = this.visitDetail.toolList;
        } else if (this.jobDetail.toolList?.length > 0) {
          this.stepThreeObj.toolList = this.jobDetail.toolList;
        }

        // Items (if visit exists)
        if (this.visitDetail.visitId) {
          this.loadVisitItems(this.visitDetail.visitId);
        }
      }

      // --- 7. JOB TYPE SELECTION (highlight correct chip) ---
      this.$nextTick(() => {
        if (this.stepTwoObj.jobTypeId && this.jobTypeList.length > 0) {
          const matchedType = this.jobTypeList.find(t => t.jobTypeId === this.stepTwoObj.jobTypeId);
          if (matchedType) {
            this.displayJobTypeName = matchedType.jobTypeName;
          }
        }
      });

      this.$nextTick(() => {
        this.isInitializingEditMode = false;
      });
    },
    loadVisitItems(visitId) {
      MyJobApp.getVisitItemList(
        visitId,
        this.jobDetail.jobId,
        response => {
          if (response.Data.tableRow && response.Data.tableRow.length > 0) {
            const items = response.Data.tableRow;
            this.stepThreeObj.itemList = [...items];
          }
        },
        (error) => {
          console.error('Failed to load visit items:', error);
        }
      );
    },
    setAssignedEmployeesInEdit(assignToList) {
      this.selectedEmployee = assignToList.map(assignedUser => {
        const employee = this.employeeList.find(emp => emp.userDetailId === assignedUser.userDetailId);

        if (employee) {
          let firstInitial = '';
          let lastName = '';

          if (employee.firstName && employee.lastName) {
            firstInitial = employee.firstName.charAt(0).toUpperCase() + '.';
            lastName = employee.lastName;
          } else if (employee.fullName) {
            const parts = employee.fullName.split(' ');
            if (parts.length >= 2) {
              firstInitial = parts[0].charAt(0).toUpperCase() + '.';
              lastName = parts.slice(1).join(' ');
            } else {
              lastName = parts[0];
            }
          }

          return {
            ...employee,
            fullName: firstInitial + ' ' + lastName,
            isSelect: true
          };
        }

        return null;
      }).filter(emp => emp !== null);

      // stepThreeObj.assignToList is already set in correct format in initializeEditMode
      // But we need to emit the event for child components
      this.$root.$emit('setSelectedEmpHandler', this.stepThreeObj.assignToList);
    },
    closePopup() {
      this.$emit('close');
    },
    SearchNewAddress(isActive) {
      this.addNewjobAdd = isActive;
    },
    SetLocationCreateJobHanler() {
      this.addOther = false;
    },
    openSelectToolPopup() {
      this.isSelectTool = true;
    },
    uppdateToollist(data) {
      this.toolMainList.push(data);
    },
    selectToolHandler(data) {
      if (data !== null) {
        this.stepThreeObj.toolList = data;
      }
      this.isSelectTool = false;
    },
    deleteCheckItem(index) {
      this.jobCheckList.splice(index, 1);
    },
    addcheckLiItem() {
      this.jobCheckList.push({ checkLiTitle: '' });
    },
    openChecklistPopup() {
      this.isSelectChecklist = true;
    },
    handleChecklistSave(checklist) {
      if (checklist !== null) {
        this.jobCheckList = checklist;
      }
      this.isSelectChecklist = false;
    },
    openSelectEmployeePopup() {
      this.isSelectEmployee = true;
    },
    handleEmployeeSelect(employeeList) {
      if (employeeList !== null) {
        this.selectEmployee(employeeList);
      }
      this.isSelectEmployee = false;
    },
    selectEmployee(emplist) {
      this.selectedEmployee = emplist.map(data => {
        let firstInitial = '';
        let lastName = '';

        if (data.firstName && data.lastName) {
          firstInitial = data.firstName.charAt(0).toUpperCase() + '.';
          lastName = data.lastName;
        } else if (data.fullName) {
          const parts = data.fullName.split(' ');
          if (parts.length >= 2) {
            firstInitial = parts[0].charAt(0).toUpperCase() + '.';
            lastName = parts.slice(1).join(' ');
          } else {
            lastName = parts[0];
          }
        }

        return {
          ...data,
          fullName: firstInitial + ' ' + lastName,
          isSelect: true
        };
      });
      this.$root.$emit('setSelectedEmpHandler', emplist.map(item => ({ userDetailId: item.userDetailId })));
    },
    setDefaultEmployee() {
      if (this.employeeList.length > 0) {
        const activeUser = JSON.parse(localStorage.getItem('jobUserInfo'))?.userDetailId;
        const defaultEmployee = this.employeeList.find(el => el.userDetailId === (this.assignUser || activeUser));
        if (defaultEmployee) {
          const formattedName = `${defaultEmployee.firstName ? defaultEmployee.firstName.charAt(0).toUpperCase() + '.' : ''} ${defaultEmployee.lastName} (me)`;
          this.selectedEmployee = [{
            ...defaultEmployee,
            fullName: formattedName.trim(),
            isSelect: true
          }];
          this.$root.$emit('setSelectedEmpHandler', [{ userDetailId: defaultEmployee.userDetailId }]);
        }
      }
    },
    getEmployeeList() {
      MyJobApp.getEmployeeList(
        'active',
        response => {
          const tempList = response.Data.tableRow?.map(el => {
            const fullName = `${el.firstName} ${el.lastName}`;
            let jobText = "";
            if (el.jobCount === 1) {
              jobText = "1 job is open";
            } else if (el.jobCount > 1) {
              jobText = `${el.jobCount} jobs are open`;
            } else {
              jobText = "No jobs assigned";
            }

            return {
              ...el,
              fullName: fullName,
              displayName: `${fullName}\n<span class="job-count-text">${jobText}</span>`
            };
          }) || [];

          this.employeeList = tempList;

          // If in edit mode and we have pending assignToList, set it now
          if (this.isEditMode && this.pendingAssignToList?.length > 0) {
            this.$nextTick(() => {
              this.setAssignedEmployeesInEdit(this.pendingAssignToList);
              this.pendingAssignToList = null; // Clear after use
            });
          } else if (!this.isEditMode) {
            this.setDefaultEmployee();
          }
        },
        error => {
          console.error('Error loading employees:', error);
        }
      );
    },
    addNewAddress() {
      this.addOther = true;
    },
    callsearchCust(text) {
      this.searchApitext = text;
      this.getCustList();
    },
    getCustomerList() {
      this.customersList = [];
      MyJobApp.getGlobalCustLeadList(
        0,
        500,
        this.searchApitext,
        "",
        (response) => {
          let tempList = response.Data.tableRow !== null ? response.Data.tableRow : [];
          tempList.forEach((e) => {
            let lead = e.isLead ? "(lead)" : "(customer)";
            e.companyName = e.companyName + " " + lead;
            let jobText = "";
            if (e.jobCount === 1) {
              jobText = "1 job is open";
            } else {
              jobText = `${e.jobCount} jobs are open`;
            }
            // Final display name for dropdown - companyName already includes lead text
            // Wrap jobText in span for styling
            e.displayName = `${e.companyName}\n<span class="job-count-text">${jobText}</span>`;
            this.customersList.push(e);
          });
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        },
        () => {
          this.resetPaginationValues = false;
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        }
      );
    },
    addNewCustomer() {
      this.addCustomer = true;
    },
    selectNewCustomer(data) {
      if (data !== null && this.addJobObj.customerId > 0 && this.addJobObj.customerId !== data.customerId) {
        this.pendingCustomerData = data;
        this.showCustomerChangeConfirm = true;
        return;
      }
      this.applyCustomerChange(data);
    },
    applyCustomerChange(data) {
      this.errObj.addressErr = "";
      if (data !== null) {
        this.islead = data.isLead;
        this.jobDisplayAdd = "";
        this.addJobObj.addressLine1 = "";
        this.addJobObj.addressTitle = "";
        this.addJobObj.addressLine2 = "";
        this.addJobObj.city = "";
        this.addJobObj.state = "";
        this.addJobObj.zip = "";
        this.addJobObj.latitude = 0;
        this.addJobObj.longitude = 0;
        this.addJobObj.country = "";
        this.addJobObj.directionNote = "";
        this.addJobObj.houseNo = "";
        this.addJobObj.floorNumber = "";
        this.addJobObj.buildingName = "";
        this.addressList = [];
        this.addressDropdownItems = [];
        this.selectedAddress = null;
        this.selectedAddressLabel = '';
        this.isOfficeAddressSel = false;
        this.isAddedNewAddress = false;
        this.errObj.custErr = "";
        this.searchForCustomer = data.companyName;
        this.addJobObj.customerId = data.customerId;
        this.showAddSelectAddr = true;
        this.getCustDetails(data.customerId);
      } else {
        this.searchForCustomer = "";
        this.addJobObj.customerId = 0;
        this.custDetail = null;
        this.showAddSelectAddr = false;
        this.selectedAddress = null;
        this.selectedAddressLabel = '';
        this.addressDropdownItems = [];
        this.addressList = [];
      }
    },
    setCustomerDetail() {
      // === 1. Always set the customer name in search field ===
      this.searchForCustomer = this.custDetail.companyName || '';

      // === 2. Always rebuild the address dropdown options (needed for UI) ===
      this.addressDropdownItems = [];
      this.addressList = [];

      // Build customer addresses with distance
      if (this.custDetail.addressList && this.custDetail.addressList.length > 0) {
        this.custDetail.addressList.forEach(e => {
          let dist = 0;
          let suffix = '';
          if (this.LoginUserlatLong) {
            dist = this.calcDistance(
              this.LoginUserlatLong.latitude,
              this.LoginUserlatLong.longitude,
              e.latitude,
              e.longitude
            );
            suffix = ' from user';
          } else if (this.OfficelatLong) {
            dist = this.calcDistance(
              this.OfficelatLong.latitude,
              this.OfficelatLong.longitude,
              e.latitude,
              e.longitude
            );
            suffix = ' from office';
          }

          const distanceLabel = dist > 0 ? this.getDistanceUnit(dist * 1000) + suffix : '';
          const addrObj = {
            ...e,
            selected: false,
            displayDistance: distanceLabel,
            addressText: `${e.addressTitle || 'Other'} - ${e.fullAddress}`
          };

          this.addressList.push(addrObj);
          this.addressDropdownItems.push({
            label: addrObj.addressText,
            value: { type: 'customer', data: addrObj }
          });
        });
      }

      // Add Office Location option
      const officeAddrObj = this.custDetail.organisationOfficeAddress?.[0];
      const officeFullAddress = officeAddrObj?.fullAddress || '';
      const truncated = officeFullAddress.length > 60 ? officeFullAddress.substring(0, 60) + '...' : officeFullAddress;

      this.addressDropdownItems.push({
        label: officeFullAddress ? `Office Location - ${truncated}` : 'Office Location',
        value: { type: 'office', address: officeFullAddress, data: officeAddrObj }
      });

      // ==================================================================
      // EDIT MODE: Restore the EXACT address that belongs to this job
      // This runs only once during initialization
      // ==================================================================
      if (this.isEditMode && this.editModeOriginalAddress && this.isInitializingEditMode) {
        const orig = this.editModeOriginalAddress;

        // Case 1: Match by lat/lng + fullAddress (most reliable)
        const matchedCustomerAddr = this.addressList.find(a =>
          a.latitude === orig.latitude &&
          a.longitude === orig.longitude &&
          a.fullAddress === orig.fullAddress
        );

        if (matchedCustomerAddr) {
          // Found in customer's saved addresses → select it
          this.selectedAddress = { type: 'customer', data: matchedCustomerAddr };
          this.selectedAddressLabel = matchedCustomerAddr.addressTitle
            ? `${matchedCustomerAddr.addressTitle} - ${matchedCustomerAddr.fullAddress}`
            : matchedCustomerAddr.fullAddress;
          this.selectJobAddress(matchedCustomerAddr, -1);
        }
        // Case 2: Office address
        else if (
          orig.addressTitle === 'Office Location' ||
          this.jobDetail?.isOfficeAddress ||
          (officeAddrObj && orig.latitude === officeAddrObj.latitude && orig.longitude === officeAddrObj.longitude)
        ) {
          this.selectedAddress = { type: 'office', address: officeFullAddress, data: officeAddrObj };
          this.selectedAddressLabel = `Office Location - ${officeFullAddress.substring(0, 75)}${officeFullAddress.length > 75 ? '...' : ''}`;
          this.checkboxCheck(); // This populates addJobObj correctly
        }
        // Case 3: One-time / custom address (not in customer list)
        else {
          this.isAddedNewAddress = true;
          this.selectedAddress = { type: 'customer', data: orig };
          this.selectedAddressLabel = orig.addressTitle
            ? `${orig.addressTitle} - ${orig.fullAddress}`
            : orig.fullAddress;

          // Directly restore all address fields
          Object.assign(this.addJobObj, {
            addressTitle: orig.addressTitle || '',
            fullAddress: orig.fullAddress || '',
            addressLine1: orig.addressLine1 || '',
            addressLine2: orig.addressLine2 || '',
            city: orig.city || '',
            state: orig.state || '',
            zip: orig.zip || '',
            country: orig.country || '',
            latitude: orig.latitude || 0,
            longitude: orig.longitude || 0,
            houseNo: orig.houseNo || '',
            floorNumber: orig.floorNumber || '',
            buildingName: orig.buildingName || '',
            directionNote: orig.directionNote || '',
            contactName: orig.contactName || '',
            contactNumber: orig.contactNumber || '',
            geofenceRangeDiameter: orig.geofenceRangeDiameter || 100,
          });
        }

        // Mark initialization as complete
        this.$nextTick(() => {
          this.isInitializingEditMode = false;
        });

        return; // Stop here — we’re done!
      }

      // ==================================================================
      // CREATE MODE: Auto-select first address if none selected
      // ==================================================================
      if (!this.isEditMode && this.addressDropdownItems.length > 0 && !this.selectedAddress) {
        this.$nextTick(() => {
          this.handleAddressSelect(this.addressDropdownItems[0]);
        });
      }
    },
    checkCustomerSelected(event) {
      if (this.custDetail === null) {
        event.stopPropagation();
        event.preventDefault();
        this.showSelectCustomerFirst = true;
      }
    },
    handleSelectCustomerFirstConfirm() {
      this.showSelectCustomerFirst = false;
      document.body.style.overflow = 'hidden';
    },
    handleAddressSelect(item) {
      const selected = item ? item.value : null;

      this.errObj.addressErr = "";

      if (!selected) {
        this.selectedAddress = null;
        this.selectedAddressLabel = '';
        this.resetAddressFields();
        return;
      }

      this.selectedAddress = selected;

      // Show both title and complete location
      if (selected.type === 'customer') {
        const title = selected.data.addressTitle || 'Other';
        const fullAddress = selected.data.fullAddress || '';
        this.selectedAddressLabel = fullAddress ? `${title} - ${fullAddress}` : title;
      } else if (selected.type === 'office') {
        this.checkboxCheck(); // This now fully populates addJobObj
      }

      if (selected.type === 'customer') {
        this.selectJobAddress(selected.data, -1);
        this.isOfficeAddressSel = false;
        this.isAddedNewAddress = false;
      } else if (selected.type === 'office') {
        this.checkboxCheck();
        this.isOfficeAddressSel = true;
        this.isAddedNewAddress = false;
      }
    },
    resetAddressFields() {
      this.addJobObj.addressLine1 = "";
      this.addJobObj.addressLine2 = "";
      this.addJobObj.city = "";
      this.addJobObj.state = "";
      this.addJobObj.zip = "";
      this.addJobObj.latitude = 0;
      this.addJobObj.longitude = 0;
      this.addJobObj.fullAddress = "";
      this.addJobObj.addressTitle = "";
      this.isOfficeAddressSel = false;
      this.isAddedNewAddress = false;
    },
    getCustDetails(custId) {
      MyJobApp.getCustomerDetail(
        custId,
        (response) => {
          this.custDetail = response.Data;
          this.setCustomerDetail();
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        },
        () => {
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        }
      );
    },
    saveAddressToCustomer(data) {
      // Save the new address to the customer's address list
      const addressData = {
        customerAddressId: 0,
        customerId: this.custDetail.customerId,
        addressTitle: data.addressTitle || '',
        addressLine1: data.addressLine1 || '',
        addressLine2: data.addressLine2 || '',
        city: data.city || '',
        state: data.state || '',
        zip: data.zip || '',
        country: data.country || '',
        latitude: data.latitude || 0,
        longitude: data.longitude || 0,
        fullAddress: data.fullAddress || '',
        houseNo: data.houseNo || '',
        floorNumber: data.floorNumber || '',
        buildingName: data.buildingName || '',
        directionNote: data.directionNote || '',
        selectedRadius: data.selectedRadius || 0,
        contactNumber: data.contactNumber || '',
        contactName: data.contactName || ''
      };

      this.$store.dispatch("SetLoader", { status: true, message: "Saving address..." });
      MyJobApp.addCustomerAddress(
        addressData,
        response => {
          this.$store.dispatch('SetAlert', { showAlert: true, message: response.message, color: 'success' });
          this.$store.dispatch('SetLoader', { status: false, message: '' });
          // Refresh customer details to get updated address list
          this.getCustDetails(this.custDetail.customerId);
        },
        error => {
          this.$store.dispatch('SetAlert', { showAlert: true, message: error.message, color: 'error' });
          this.$store.dispatch('SetLoader', { status: false, message: '' });
        }
      );
    },
    updateAddressInCustomer(data) {
      // Update existing address in the customer's address list
      const addressData = {
        customerAddressId: data.customerAddressId || 0,
        customerId: this.custDetail.customerId,
        addressTitle: data.addressTitle || '',
        addressLine1: data.addressLine1 || '',
        addressLine2: data.addressLine2 || '',
        city: data.city || '',
        state: data.state || '',
        zip: data.zip || '',
        country: data.country || '',
        latitude: data.latitude || 0,
        longitude: data.longitude || 0,
        fullAddress: data.fullAddress || '',
        houseNo: data.houseNo || '',
        floorNumber: data.floorNumber || '',
        buildingName: data.buildingName || '',
        directionNote: data.directionNote || '',
        selectedRadius: data.selectedRadius || 0,
        contactNumber: data.contactNumber || '',
        contactName: data.contactName || ''
      };

      this.$store.dispatch("SetLoader", { status: true, message: "Updating address..." });
      MyJobApp.addCustomerAddress(
        addressData,
        response => {
          this.$store.dispatch('SetAlert', { showAlert: true, message: response.message, color: 'success' });
          this.$store.dispatch('SetLoader', { status: false, message: '' });
          // Refresh customer details to get updated address list
          this.getCustDetails(this.custDetail.customerId);
          // Update the local address data
          this.setAddress(data, true);
        },
        error => {
          this.$store.dispatch('SetAlert', { showAlert: true, message: error.message, color: 'error' });
          this.$store.dispatch('SetLoader', { status: false, message: '' });
        }
      );
    },
    setAddress(data, isNotNew) {
      if (!isNotNew) {
        this.isAddedNewAddress = true;
        let temp = 0;
        let temp3 = '';
        if (this.LoginUserlatLong !== null) {
          temp = this.calcDistance(this.LoginUserlatLong.latitude, this.LoginUserlatLong.longitude, data.latitude, data.longitude);
          temp3 = ` from user`;
        } else {
          temp = this.calcDistance(this.OfficelatLong.latitude, this.OfficelatLong.longitude, data.latitude, data.longitude);
          temp3 = ` from office`;
        }
        let value = this.getDistanceUnit(temp * 1000);
        this.otherLocationDistance = value + temp3;
        this.isOfficeAddressSel = false;
        this.addJobObj.isAddressAddToCustomer = true;
        this.addressList.forEach(e => { e.selected = false; });
      }
      this.jobDisplayAdd = data !== null ? data.fullAddress : "";
      this.addJobObj.addressTitle = data !== null ? data.addressTitle : "";

      // Update selectedAddressLabel to show title and complete location
      if (data !== null) {
        const title = data.addressTitle || 'Other';
        const fullAddress = data.fullAddress || '';
        this.selectedAddressLabel = fullAddress ? `${title} - ${fullAddress}` : title;
      }

      this.addJobObj.addressLine1 = data !== null ? data.addressLine1 : "";
      this.addJobObj.addressLine2 = data !== null ? data.addressLine2 : "";
      this.addJobObj.city = data !== null ? data.city : "";
      this.addJobObj.state = data !== null ? data.state : "";
      this.addJobObj.zip = data !== null ? data.zip : "";
      this.addJobObj.latitude = data !== null ? data.latitude : 0;
      this.addJobObj.longitude = data !== null ? data.longitude : 0;
      this.addJobObj.country = data !== null ? data.country : "";
      this.addJobObj.geofenceRangeDiameter = data !== null ? data.selectedRadius : "";
      this.addJobObj.fullAddress = data !== null ? data.fullAddress : "";
      this.addJobObj.houseNo = data !== null ? data.houseNo : "";
      this.addJobObj.floorNumber = data !== null ? data.floorNumber : "";
      this.addJobObj.buildingName = data !== null ? data.buildingName : "";
      this.addJobObj.directionNote = data !== null ? data.directionNote : "";
      this.addJobObj.contactNumber = data !== null ? data.contactNumber : "";
      this.addJobObj.contactName = data !== null ? data.contactName : "";
      if (this.LoginUserlatLong !== null) {
        let dist = this.calcDistance(this.LoginUserlatLong.latitude, this.LoginUserlatLong.longitude, data.latitude, data.longitude);
        let final = this.getDistanceUnit(dist * 1000);
        this.displayDistance = final + ' from user';
      } else if (this.OfficelatLong !== null) {
        let dist = this.calcDistance(this.addJobObj.latitude, this.addJobObj.longitude, this.OfficelatLong.latitude, this.OfficelatLong.longitude);
        let final = this.getDistanceUnit(dist * 1000);
        this.displayDistance = final + ' from Office';
      }
    },
    selectJobAddress(data, index) {
      this.isOfficeAddressSel = false;
      this.addressList.forEach((e, i) => {
        e.selected = index === i;
      });
      this.isAddedNewAddress = false;
      this.addedAddress = null;
      this.addJobObj.isAddressAddToCustomer = false;
      this.jobDisplayAdd = data !== null ? data.addressText : "";
      this.addJobObj.addressTitle = data !== null ? data.addressTitle : "";
      this.addJobObj.fullAddress = data !== null ? data.fullAddress : "";
      this.addJobObj.addressLine1 = data !== null ? data.addressLine1 : "";
      this.addJobObj.addressLine2 = data !== null ? data.addressLine2 : "";
      this.addJobObj.city = data !== null ? data.city : "";
      this.addJobObj.state = data !== null ? data.state : "";
      this.addJobObj.zip = data !== null ? data.zip : "";
      this.addJobObj.latitude = data !== null ? data.latitude : 0;
      this.addJobObj.longitude = data !== null ? data.longitude : 0;
      this.addJobObj.country = data !== null ? data.country : "";
      this.addJobObj.directionNote = data !== null ? data.directionNote : "";
      this.addJobObj.houseNo = data !== null ? data.houseNo : "";
      this.addJobObj.floorNumber = data !== null ? data.floorNumber : "";
      this.addJobObj.buildingName = data !== null ? data.buildingName : "";
    },
    checkboxCheck() {
      this.addressList.forEach(e => { e.selected = false; });
      this.isOfficeAddressSel = true;
      this.isAddedNewAddress = false;
      this.addedAddress = null;
      this.errObj.addressErr = "";
      // Get office address from custDetail (which has organisationOfficeAddress)
      if (this.custDetail && this.custDetail.organisationOfficeAddress && this.custDetail.organisationOfficeAddress.length > 0) {
        const office = this.custDetail.organisationOfficeAddress[0];

        // Populate addJobObj with actual office address data
        this.addJobObj.addressTitle = 'Office Location';
        this.addJobObj.fullAddress = office.fullAddress || '';
        this.addJobObj.addressLine1 = office.addressLine1 || '';
        this.addJobObj.addressLine2 = office.addressLine2 || '';
        this.addJobObj.city = office.city || '';
        this.addJobObj.state = office.state || '';
        this.addJobObj.zip = office.zip || '';
        this.addJobObj.country = office.country || '';
        this.addJobObj.latitude = office.latitude || 0;
        this.addJobObj.longitude = office.longitude || 0;
        this.addJobObj.geofenceRangeDiameter = office.selectedRadius || 100; // fallback
        this.addJobObj.houseNo = office.houseNo || '';
        this.addJobObj.floorNumber = office.floorNumber || '';
        this.addJobObj.buildingName = office.buildingName || '';
        this.addJobObj.directionNote = office.directionNote || '';
        this.addJobObj.contactNumber = office.contactNumber || '';
        this.addJobObj.contactName = office.contactName || '';
      } else {
        // Fallback: clear fields if no office address exists (shouldn't happen)
        this.resetAddressFields();
        this.addJobObj.addressTitle = 'Office Location';
      }
      // Update displayed label
      const officeAddr = this.custDetail?.organisationOfficeAddress?.[0]?.fullAddress || 'Office Location';
      this.selectedAddressLabel = `Office Location - ${officeAddr.substring(0, 75)}${officeAddr.length > 75 ? '...' : ''}`;      
      if (!this.isOfficeAddressSel) {
        this.getCustDetails(this.addJobObj.customerId);
      }
    },
    saveForm() {
        let isValid = true
        if (this.addJobObj.jobTitle.trim() === "") {
            this.errObj.titleErr = "Job title is required"
            isValid = false
        }
        if (!this.isEditMode && this.addJobObj.customerId === 0) {
            this.errObj.custErr = "Please select customer"
            isValid = false
        }
        if (!isValid) return

        this.$store.dispatch("SetLoader", { status: true, message: "Saving..." })
        
        // Build checklist
        let filteredChecklist = this.jobCheckList?.filter(item => item.checkLiTitle?.trim() !== '') || []
        console.log("saving form", filteredChecklist)
        let visitCheckListStr = filteredChecklist.length > 0 ? JSON.stringify(filteredChecklist) : ""

        // Get job start and end times safely
        let jobStartTime = null;
        let jobEndTime = null;
        if (this.stepThreeObj.visitList && this.stepThreeObj.visitList.length > 0) {
            jobStartTime = this.stepThreeObj.visitList[0].visitStartDateTime || null;
            jobEndTime = this.stepThreeObj.visitList[0].visitEndDateTime || null;
        }

        // Prepare final payload
        const payload = {
            jobId: this.addJobObj.jobId || 0,
            customerId: this.addJobObj.customerId,
            jobTitle: this.addJobObj.jobTitle.trim(),
            jobDescription: this.stepTwoObj.jobDescription,
            jobStartTime: jobStartTime,
            jobEndTime: jobEndTime,
            isBillable: this.stepTwoObj.isBillable,
            jobTypeId: this.stepTwoObj.jobTypeId,
            isVipJob: this.stepTwoObj.isVipJob,
            jobEstimation: 1440,

            // Address
            addressLine1: this.addJobObj.addressLine1 || "",
            addressLine2: this.addJobObj.addressLine2 || "",
            city: this.addJobObj.city || "",
            state: this.addJobObj.state || "",
            zip: this.addJobObj.zip || "",
            country: this.addJobObj.country || "",
            latitude: this.addJobObj.latitude || 0,
            longitude: this.addJobObj.longitude || 0,
            geofenceRangeDiameter: this.addJobObj.geofenceRangeDiameter || 100,
            fullAddress: this.addJobObj.fullAddress || "",
            houseNo: this.addJobObj.houseNo || "",
            floorNumber: this.addJobObj.floorNumber || "",
            buildingName: this.addJobObj.buildingName || "",
            directionNote: this.addJobObj.directionNote || "",
            contactNumber: this.addJobObj.contactNumber || "",
            contactName: this.addJobObj.contactName || "",
            addressTitle: this.addJobObj.addressTitle || "",
            isAddressAddToCustomer: this.addJobObj.isAddressAddToCustomer,

            isUnschedule: this.stepThreeObj.isUnschedule,
            visitList: this.stepThreeObj.visitList || [],
            assignToList: this.stepThreeObj.assignToList || [],
            itemList: this.stepThreeObj.itemList || [],
            toolList: this.stepThreeObj.toolList || [],
            checkList: this.jobCheckList?.map(c => ({ checkListItemMasterId: c.checkListItemMasterId || 0 })) || [],
            visitCheckList: visitCheckListStr,

            requestType: this.addJobObj.requestType || "",
            detailId: this.addJobObj.detailId || 0,

            repeatedType: "",
            repeatedDayOrDate: 0,
            noOfVisit: 0
        }

        MyJobApp.createNewJob(
            payload,
            (response) => {
                this.$store.dispatch("SetLoader", { status: false, message: "" })
                this.$store.dispatch("SetAlert", {
                    showAlert: true,
                    message: this.isEditMode ? "Job updated successfully" : "Job created successfully",
                    color: "success"
                })

                if (!this.isEditMode) {
                    this.$router.push({ name: 'jobDetail', params: { jobId: response.Data } })
                } else {
                    this.$emit('jobUpdated', response.Data)
                }
                this.closePopup()
            },
            (error) => {
                this.$store.dispatch("SetLoader", { status: false, message: "" })
                this.$store.dispatch("SetAlert", { showAlert: true, message: error.message || "Failed to save job", color: "error" })
            }
        )
    },
    handleCustomerChangeConfirm(confirmed) {
      if (confirmed) {
        this.applyCustomerChange(this.pendingCustomerData);
      } else {
        if (this.custDetail) {
          this.searchForCustomer = this.custDetail.companyName;
        }
      }
      this.showCustomerChangeConfirm = false;
      this.pendingCustomerData = null;
      document.body.style = 'overflow: visible;';
    },
    selectJobType(data) {
      // this.jobCheckList = JSON.parse(data.jobCheckList);
      this.hourInputValue = 1440;
      this.minInputValue = 0;
      this.stepTwoObj.jobTypeId = data.jobTypeId;
      this.displayJobTypeName = data.jobTypeName;
      this.setDisplayEstimation();
    },
    setDisplayEstimation() {
      this.displayEstimation = '24 Hr';
    },
    jobTypelist() {
      MyJobApp.jobTypelist(
        (response) => {
          this.jobTypeList = response.Data;

          // Only select default type if NOT in edit mode
          if (!this.isEditMode) {
            let defaultType = this.jobTypeList.find(type => type.IsDefault === true);
            if (defaultType) {
              this.selectJobType(defaultType);
            }
          } else {
            // In edit mode, update the display name based on the already-set jobTypeId
            if (this.stepTwoObj.jobTypeId) {
              const matchedType = this.jobTypeList.find(t => t.jobTypeId === this.stepTwoObj.jobTypeId);
              if (matchedType) {
                this.displayJobTypeName = matchedType.jobTypeName;
              }
            }
          }
        },
        (err) => {
          this.$store.dispatch("SetAlert", { showAlert: true, message: err.message, color: "error" });
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        }
      );
    },
    getToolList() {
      this.toolMainList = []; // Clear the array first
      MyJobApp.getToolList(
        (response) => {
          response.Data.forEach(element => {
            this.toolMainList.push({ ...element, selected: false });
          });
        },
        () => {
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        }
      );
    },
    getDistanceUnit(distanceMeter) {
      let distance = '';
      let countryCode;
      const moment = require('moment-timezone');
      const countryTimeZone = moment.tz.guess();
      timeZoneWithCountryCode.map(itm => {
        const ind = itm.timezones.findIndex(x => x.name === countryTimeZone);
        if (ind >= 0) {
          countryCode = itm.code;
        }
      });
      const index = milesCountry.findIndex(x => x.countryCode === countryCode);
      if (index >= 0) {
        if (distanceMeter * 0.00062137 >= 1000) {
          distance = `999+ mi`;
        } else if (distanceMeter * 0.00062137 < 0.1) {
          distance = '';
        } else {
          distance = `${(distanceMeter * 0.00062137).toFixed(1)} mi`;
        }
      } else if (distanceMeter / 1000 >= 1000) {
        distance = `999+ km`;
      } else if (distanceMeter / 1000 < 0.1) {
        distance = '';
      } else {
        distance = `${(distanceMeter / 1000).toFixed(1)} km`;
      }
      return distance;
    },
    calcDistance(lat1, lon1, lat2, lon2) {
      const radius = 6371;
      const dLat = this.toRadians(lat2 - lat1);
      const dLng = this.toRadians(lon2 - lon1);
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(this.toRadians(lat1)) * Math.cos(this.toRadians(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = radius * c;
      return distance.toFixed(2);
    },
    toRadians(degree) {
      return degree * (Math.PI / 180);
    },
  },
};
</script>

<style scoped>
/* Override overFlowParaA for customer dropdown to allow multi-line display */
:deep(#customerlistid .overFlowParaA) {
  white-space: pre-line !important;
  overflow: visible !important;
  text-overflow: initial !important;
  min-height: auto !important;
}

/* Style the job count text (second line) */
:deep(#customerlistid .job-count-text) {
  font-size: 0.75rem !important; /* Smaller font for job text */
  color: var(--primary) !important; /* Primary color for job text */
  display: block !important;
}

</style>
